import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/x.png'
import _imports_1 from '../assets/icons/facebook.png'
import _imports_2 from '../assets/icons/whatsapp.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4cc0f87f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "head"
}
const _hoisted_2 = { class: "top-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "top-story" }
const _hoisted_5 = { class: "top-img" }
const _hoisted_6 = { class: "socials" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"margin-right":"7px"},
  width: "15",
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "15",
  style: {"margin-right":"7px"},
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "17",
  style: {"margin-right":"7px"},
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "story" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "story1" }, null, -1))
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    (_ctx.blog.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.blog.data.description), 1),
            _createElementVNode("p", null, _toDisplayString(new Date(_ctx.blog.data.createdAt.seconds * 1000).toDateString()), 1),
            _hoisted_3
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                style: _normalizeStyle({ backgroundImage: `url(${_ctx.blog.data.displayURL})` }),
                class: "img"
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.twitter && _ctx.twitter(...args)))
              }, [
                _hoisted_7,
                _createTextVNode(" share ")
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.facebook && _ctx.facebook(...args)))
              }, [
                _hoisted_8,
                _createTextVNode(" share ")
              ]),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.whatsapp && _ctx.whatsapp(...args)))
              }, [
                _hoisted_9,
                _createTextVNode(" share ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", {
              class: "story2",
              innerHTML: _ctx.blog.data.body
            }, null, 8, _hoisted_12)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_13,
    _createVNode(_component_Footer)
  ]))
}